import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HunaButtonComponent} from './huna-button/huna-button.component';
import {HunaLoadContentComponent} from './huna-load-content/huna-load-content.component';
import {NextAfterDataComponent} from './next-after-data/next-after-data.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from '../providers/pipes/pipes.module';
import {DirectivesModule} from '../providers/directives/directives.module';
import {AutoCompleteFormComponent} from './auto-complete-form/auto-complete-form.component';
import {
    GetFormFieldFromConfigurationFileComponent
} from './get-form-field-from-configuration-file/get-form-field-from-configuration-file.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatBadgeModule} from '@angular/material/badge';
import {MoveDateWithRangeComponent} from './move-date-with-range/move-date-with-range.component';
import {SplitScreenComponent} from './split-screen/split-screen.component';
import {UploadFileComponent} from './upload-file/upload-file.component';
import {PinchToZoomComponent} from './pinch-to-zoom/pinch-to-zoom.component';
import {SearchLocationFormFieldComponent} from './search-location-form-field/search-location-form-field.component';
import {InputTextArrayFormFieldComponent} from './input-text-array-form-field/input-text-array-form-field.component';
import {TruncateTextComponent} from './truncate-text/truncate-text.component';
import {
    FieldStatementSensorEventComponent
} from './field-statement-sensor-event/field-statement-sensor-event.component';
import {
    FormFieldActuatorsSensorEventComponent
} from './form-field-actuators-sensor-event/form-field-actuators-sensor-event.component';
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatRadioModule} from "@angular/material/radio";
import {MatSelectModule} from "@angular/material/select";
import {MatInputModule} from "@angular/material/input";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatCardModule} from "@angular/material/card";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatButtonModule} from "@angular/material/button";
import {OnOffSlideButtonComponent} from './on-off-slide-button/on-off-slide-button.component';
import {KeyValuesFieldComponent} from './key-values-field/key-values-field.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatListModule} from "@angular/material/list";
import {MultiSelectFormFieldComponent} from './multi-select-form-field/multi-select-form-field.component';
import {ScrollWithButtonComponent} from './scroll-with-button/scroll-with-button.component';
import {MatSliderModule} from "@angular/material/slider";
import {IncrementFieldComponent} from './increment-field/increment-field.component';
import {
    FormFieldSelectWithFilterComponent
} from './form-field-select-with-filter/form-field-select-with-filter.component';
import {MatIconModule} from "@angular/material/icon";
import {FormFieldChipsComponent} from './form-field-chips/form-field-chips.component';
import {MatChipsModule} from "@angular/material/chips";
import {MatMenuModule} from "@angular/material/menu";
import {FormFieldNextDateComponent} from './form-field-next-date/form-field-next-date.component';
import {HunaToolbarComponent} from './huna-toolbar/huna-toolbar.component';
import {
    FormFieldChipsWithMultiSelectComponent
} from "./form-field-chips-with-multi-select/form-field-chips-with-multi-select.component";
import {FormFieldRangeComponent} from './form-field-range/form-field-range.component';
import {CustomSensorDataTraductionPipe} from "../providers/pipes/custom-sensor-data-traduction.pipe";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {BoxCalendarComponent} from "../boxes/box-calendar/box-calendar.component";
import {FormFieldExternalInfoComponent} from "./form-field-external-info/form-field-external-info.component";
import {MatAccordion, MatExpansionModule} from "@angular/material/expansion";
import { FormFieldExternalCommandComponent } from "./form-field-external-command/form-field-external-command.component";


@NgModule({
    declarations: [HunaButtonComponent, HunaLoadContentComponent, NextAfterDataComponent, AutoCompleteFormComponent, GetFormFieldFromConfigurationFileComponent, MoveDateWithRangeComponent, SplitScreenComponent, UploadFileComponent, PinchToZoomComponent, SearchLocationFormFieldComponent, InputTextArrayFormFieldComponent, TruncateTextComponent, FieldStatementSensorEventComponent, FormFieldActuatorsSensorEventComponent, OnOffSlideButtonComponent, KeyValuesFieldComponent, MultiSelectFormFieldComponent, ScrollWithButtonComponent, IncrementFieldComponent, FormFieldSelectWithFilterComponent, FormFieldChipsComponent, FormFieldNextDateComponent, HunaToolbarComponent, FormFieldChipsWithMultiSelectComponent, FormFieldRangeComponent,FormFieldExternalInfoComponent],
    exports: [
        HunaButtonComponent,
        HunaLoadContentComponent,
        NextAfterDataComponent,
        AutoCompleteFormComponent,
        GetFormFieldFromConfigurationFileComponent,
        MoveDateWithRangeComponent,
        SplitScreenComponent,
        UploadFileComponent,
        PinchToZoomComponent,
        SearchLocationFormFieldComponent,
        TruncateTextComponent,
        FieldStatementSensorEventComponent,
        FormFieldActuatorsSensorEventComponent,
        OnOffSlideButtonComponent,
        MultiSelectFormFieldComponent,
        ScrollWithButtonComponent,
        IncrementFieldComponent,
        FormFieldSelectWithFilterComponent,
        FormFieldNextDateComponent,
        HunaToolbarComponent,
        FormFieldChipsWithMultiSelectComponent,
        FormFieldRangeComponent,
        FormFieldExternalInfoComponent

    ],
    imports: [
    CommonModule,
    MatIconModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    PipesModule,
    DirectivesModule,
    TranslateModule,
    MatBadgeModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
    MatCardModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatButtonModule,
    MatDialogModule,
    MatListModule,
    MatSliderModule,
    MatIconModule,
    MatChipsModule,
    MatMenuModule,
    CustomSensorDataTraductionPipe,
    MatButtonToggleGroup,
    MatButtonToggle,
    BoxCalendarComponent,
    MatExpansionModule,
    FormFieldExternalCommandComponent
]
})
export class WidgetModule {
}
